import { Term } from 'services/terms-and-conditions/types'

import { interWbHttp } from '@interco/inter-webview-bridge'

export const getTermsRemittanceAccount = async (): Promise<Term[]> => {
  const endpoint = `app-pf/ia/cb-onboarding-bff/v1/terms`

  const { response } = await interWbHttp.get({
    endpoint,
    headers: {},
    options: {},
  })

  return JSON.parse(response)
}

export const getTermsDigitalAccount = async (institution = 'CONTINENTAL'): Promise<Term[]> => {
  const endpoint = `app-pf/ia/cb-account-update-bff/v1/terms/${institution}`

  const { response } = await interWbHttp.get({
    endpoint,
    headers: {},
    options: {},
  })

  return JSON.parse(response)
}
